<div class="pane">
    <div class="pane__header pane__header--sticky bg-white">
      <div class="header">
        <h1 class="header__heading">
          Templates
        </h1>
        <div class="header__actions">
        </div>
      </div>
    </div>
    <div class="pane__body">
      <ripple-entity-list [entityService]="teamTypeService"
        [showFilter]="false" [caption]="'Template'"
        [editButton]="edit" [addButton]="add"></ripple-entity-list>
    </div>
</div>
